import BlacklistEditor from "./BlacklistEditor.vue";
export default BlacklistEditor;
